import "core-js/modules/es.array.reduce.js";
export function flatten(values) {
  return values.reduce(function (a, b) {
    return a.concat(b);
  }, []);
}